export enum dataProvider {
  NANNY4ALL = 'NANNY4ALL',
  KINDPLANNER = 'KINDPLANNER',
  KONNECT_INTEGRATION = 'KONNECT_INTEGRATION',
  KONNECT = 'KONNECT',
  FLEX_KIDS = 'FLEX_KIDS',
  JAAMO = 'JAAMO',
  AYSIST = 'AYSIST'
}

export const enum dataProviderKey {
  PROVIDER = 'kids_data_provider',
  CUSTOMER_KEY = 'kids_data_provider_customerkey',
  USERNAME = 'kids_data_provider_username',
  PASSWORD = 'kids_data_provider_password',
  URL = 'kids_data_provider_url',
  AUTH_URL = 'kids_data_provider_authUrl',
  TOKEN = 'kids_data_provider_token'
}
